module.exports = __webpack_public_path__ + "assets/trash-bin.bc79bf24.svg";